/**
 * The name of the "your session is gone" event.
 *
 * Its own module so `config/index.ts` can announce it without importing the
 * session provider, and the provider can listen without importing the client.
 * They would otherwise import each other: the client needs to say the session
 * ended, and the provider needs the client to fetch the session.
 */
export const SESSION_EXPIRED_EVENT = "teslm:session-expired";

/** Why the session ended — carried on the CustomEvent detail. */
export type SessionExpiryReason = "expired" | "session_superseded";

/** sessionStorage key so the login screen can show a one-shot notice. */
export const AUTH_NOTICE_KEY = "teslm_auth_notice";
